import styled from 'styled-components';

export const ModalTitle = styled.div`
  font-weight: 500;
  color: ${({ theme: { palette } }) => palette.primary.main};
`;

export const ModalText = styled.div`
  margin-top: 24px;
  font-size: 16px;
  margin-bottom: 24px;
  span {
    font-weight: 500;
  }
`;
